import { useState } from 'react';
import { useActions } from 'utils/hooks';

import { Col, Row } from 'reactstrap';
import Table, { useTable } from 'common/components/table';
import TableActions from 'components/layouts/table';
import { selectAccountIsAdmin } from 'store/account/selectors';
import { useSelector } from 'react-redux';
import * as authorizationTypes from 'store/authorization/actions';

import edit from 'assets/svg/actions/edit.svg';

import useDrawer from 'common/components/drawer/useDrawer';
import Form from './form';
import TopFilters from './TopFilters';

const Authorization = () => {
  const [active, setActive] = useState(null);
  const [updateStatusTable] = useActions([authorizationTypes.updateStatusTable]);
  const accountIsAdmin = useSelector(selectAccountIsAdmin);

  const drawer = useDrawer();
  const table = useTable({
    label: 'authorization',
    columns: [
      {
        header: 'Name',
        key: 'name',
        type: 'string',
        sort: true
      },
      {
        header: 'Username',
        key: 'username',
        type: 'string',
        width: 2,
        sort: false,
        canFilter: false
      },
      {
        header: 'Ocean Admin',
        key: 'is_admin',
        className: 'text-center',
        width: 2,
        type: 'boolean',
        options: [
          { label: 'Yes', value: 'true' },
          { label: 'No', value: 'false' }
        ]
      },
      {
        header: 'Status',
        key: 'active',
        field: 'toggle',
        className: 'text-center',
        type: 'boolean',
        canFilter: false,
        sort: false,
        width: 3,
        options: [
          { label: 'active', value: 'true' },
          { label: 'inactive', value: 'false' }
        ]
      },
      {
        header: 'Actions',
        key: 'actions',
        field: 'actions',
        className: 'text-center',
        width: 1
      }
    ],
    excludedFilters: ['active'],
    top: {
      filters: [{ name: 'active', operation: '=', value: null }]
    }
  });

  return (
    <Row className="no-gutters">
      <Col xs={12} className="mb-6 mt-n1">
        <TableActions
          documentTitle="Authorization"
          title="Authorization"
          actions={[
            { type: 'search' },
            {
              type: 'add',
              text: 'Create user',
              color: 'primary',
              onClick: () => {
                setActive(null);
                drawer.open();
              }
            }
          ]}
        />
      </Col>

      <Col xs={12}>
        <Table
          topFiltersComponent={<TopFilters />}
          loader
          drawer={<Form drawer={drawer} active={active} />}
          rows={{
            active: {
              disabled: () => !accountIsAdmin,
              onChange: a => {
                updateStatusTable({ ...a, table: 'authorization' }).finally(() =>
                  table.refetchData()
                );
              }
            },
            is_admin: data =>
              data.is_admin ? (
                <span className="text-turquoise">Yes</span>
              ) : (
                <span className="text-violet">No</span>
              ),
            actions: () => ({
              options: [
                {
                  label: 'Edit',
                  icon: edit,
                  onClick: (_, row) => {
                    setActive(row);
                    drawer.open();
                  }
                }
              ]
            })
          }}
          {...table}
        />
      </Col>
    </Row>
  );
};

export default Authorization;
